import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchDatosAntecedentes(idDenuncia){
    const url=APIURLLEGALES + `/antecedentes/obtener?idDenuncia=${idDenuncia||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

}

export default ApiServiceAdapter;